// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DiAZ","footer":"styles_footer__3fsD_"};